"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UPDATE_LOCALE_DATA = exports.GET_COMMON_SERVICE_DATA = exports.COMMON_SERVICE_DATA = exports.CAPTURE_AREA_LEAD = void 0;
const GET_COMMON_SERVICE_DATA = exports.GET_COMMON_SERVICE_DATA = 'getCommonServiceData';
const UPDATE_LOCALE_DATA = exports.UPDATE_LOCALE_DATA = 'updateLocaleData';
const COMMON_SERVICE_DATA = exports.COMMON_SERVICE_DATA = 'commonServiceData';
const CAPTURE_AREA_LEAD = exports.CAPTURE_AREA_LEAD = 'captureAreaLead';